'use client'
import { FC, PropsWithChildren, useEffect, useState } from 'react'
import Link from 'next/link'
import { useDrawer, useGetTranslations, useCookieConsent, useModal, useCustomRouter } from '@/root/shared-hooks'
import { globalFont } from '@/root/modules/tuuleliinid/AppLayout/assets/globalFonts/globalFonts'
import { DayPickerProvider } from 'react-day-picker'
import { Drawer } from '@/root/components/shared/Drawer/Drawer'
import { Modal } from '@/root/components/shared/Modal/Modal'
import { CookiesBanner, CookiesTextField } from '@/root/ui/tuuleliinid/'
import Header from '@/root/modules/tuuleliinid/AppLayout/components/Header/Header'
import Footer from '@/root/modules/tuuleliinid/AppLayout/components/Footer/Footer'

export const AppLayout: FC<PropsWithChildren> = ({ children }) => {
  const { setSemiOpened, semiOpened, drawerBody } = useDrawer()
  const { getTranslation } = useGetTranslations()
  const { consent, setConsent, isInitialized } = useCookieConsent()
  const { modalBody, onClose } = useModal()

  const [hostname, setHostname] = useState('')

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setHostname(window.location.hostname)
    }
  }, [])

  const cookiesMessage = getTranslation('cookiesCollect', { url: hostname })
  const privacyPolicyText = getTranslation('privacyPolicy')

  const { locale } = useCustomRouter()

  const privacyPolicyLink = (
    <Link href={`/${locale}/content/privacypolicy/`} className="cursor-pointer underline">
      {privacyPolicyText}
    </Link>
  )

  return (
    <DayPickerProvider initialProps={{ mode: 'single' }}>
      <div className={`${globalFont.className} flex h-screen flex-col`}>
        {!consent && isInitialized && (
          <CookiesBanner
            textField={<CookiesTextField cookiesMessage={cookiesMessage} privacyPolicyLink={privacyPolicyLink} />}
            onAgree={setConsent}
          />
        )}
        <Header />
        <main className="bg-very-light grow">{children}</main>
        <Modal isOpen={Boolean(modalBody)} onClose={onClose}>
          {modalBody}
        </Modal>
        <Drawer body={drawerBody} isOpen={Boolean(drawerBody)} semiOpened={semiOpened} setSemiOpened={setSemiOpened} />
        <Footer />
      </div>
    </DayPickerProvider>
  )
}
